// import { postRequest } from '@/utils/data-fetching/config'
import type { InsightFeedbackPayload } from './types'

export async function postInsightFeedback(payload: InsightFeedbackPayload) {
  // return postRequest('/dafeed/submit', payload)
  return new Promise((resolve) => {
    resolve(console.log('Insight feedback submitted:', { payload }))
  })
}
